import { executeShortcut } from 'src/utils'

export default {
  methods: {
    focusRow (rowNumber) {
      const rowElement = document.getElementById(`${this.name}-row-${rowNumber}`)

      if (!rowElement) {
        return
      }

      const focusableElement = rowElement.querySelector(
        'input, button, select, textarea, a[href], [tabindex]:not([tabindex="-1"])'
      ) || rowElement.firstElementChild || rowElement

      if (typeof focusableElement.focus === 'function') {
        focusableElement.focus()
      }
    },
    keyboardEventRow ({event, rowNumber}) {
      const actions = {
        'up': () => {
          const to = rowNumber - 1

          if (to < 0) return this.executeSearchInHeader()
          this.focusRow(to)
        },
        'down': () => {
          const to = rowNumber + 1

          if (to >= this.toDisplay.length) {
            // todo make go to next page
            return
          }
          this.focusRow(to)
        },
        'esc': () => this.closeDetailsBox(),
        'left': () => {
          if (this.currentPage - 1 >= 0) this.changePage(this.currentPage - 1)
        },
        'right': () => {
          if (this.currentPage + 1 < this.totalPages) this.changePage(this.currentPage + 1)
        },
        'left+ctrl': () => {
          this.changePage(0)
          this.$nextTick(() => this.focusRow(0))
        },
        'right+ctrl': () => {
          this.changePage(this.totalPages - 1)
          this.$nextTick(() => this.focusRow(0))
        }
      }

      event.preventDefault()
      event.returnValue = false
      const {executedShortcut} = executeShortcut(event, actions)

      if (!executedShortcut && !event.shiftKey && !event.ctrlKey) {
        // assume that user is trying to search, lets focus in header
        // only use key as search if is a number or letter
        this.executeSearchInHeader(
          (/^[0-9a-z ]$/i).test(event.key)
            ? event.key : ''
        )
      }
    },
    executeSearchInHeader (text) {
      if (this.lastSearchedField) {
        this.focusHeaderSearch(this.lastSearchedField, text)
      } else if (this.mergedConfig.defaultColumnSearch) {
        this.focusHeaderSearch(this.mergedConfig.defaultColumnSearch, text)
      } else {
        this.focusHeaderSearch(null, text)
      }
    }
  }
}
